/**
 * A preferência "índice de artefatos na RÉGUA" em `localStorage`
 * (`CHAVE_DA_REGUA_NO_STORAGE`, `'1'`): quem minimizou o menu quer a régua
 * nas próximas conversas também; expandir apaga. `try/catch` nos dois
 * sentidos: modo anônimo / storage bloqueado ou cheio não pode derrubar o
 * índice — nasce sem preferência, e ela vale só nesta sessão.
 *
 * (Substituiu `iaChatIndiceArtefatosMinimizado` em 14/09/2026, quando o chip
 * saiu — sem migração: a chave antiga simplesmente deixa de ser lida.)
 */
import { CHAVE_DA_REGUA_NO_STORAGE, MARCA_DE_REGUA } from './chat-indice-artefatos.constantes'

export function lerPrefereRegua() {
  try {
    return globalThis.localStorage.getItem(CHAVE_DA_REGUA_NO_STORAGE) === MARCA_DE_REGUA
  } catch {
    // storage bloqueado (modo anônimo): nasce sem preferência
    return false
  }
}

export function gravarPrefereRegua(prefere) {
  try {
    if (prefere) {
      globalThis.localStorage.setItem(CHAVE_DA_REGUA_NO_STORAGE, MARCA_DE_REGUA)
      return
    }
    globalThis.localStorage.removeItem(CHAVE_DA_REGUA_NO_STORAGE)
  } catch {
    // storage cheio/bloqueado: a preferência vale só nesta sessão
  }
}
